<template>
  <v-row>
    <v-col class="mt-2" cols="12" offset-lg="1" lg="10">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />
      <v-card>
        <v-card-title class="theme">
          <v-icon class="white--text">receipt_long</v-icon>
          <span class="headline ml-2 white--text">Edit department</span>
          <v-spacer />
          <v-btn depressed @click="dialog = true" class="error rounded-sm"
            >delete</v-btn
          >
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-form ref="form">
            <v-container>
              <v-row>
                <v-col cols="12" md="5">
                  <v-text-field
                    label="Department Name*"
                    persistent-hint
                    :rules="[validationRules.required]"
                    :disabled="tempDisable"
                    hint="Name of the department e.g. Accounts"
                    class="my-4"
                    v-model="department.name"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small class="grey--text pt-1" v-on="on"
                            >help</v-icon
                          >
                        </template>
                        Provide a name for the department.
                      </v-tooltip>
                    </template>
                  </v-text-field>

                  <v-textarea
                    label="Additional information"
                    :disabled="tempDisable"
                    persistent-hint
                    rows="4"
                    v-model="department.description"
                    class="my-4"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small class="grey--text pt-1" v-on="on"
                            >help</v-icon
                          >
                        </template>
                        Any additional information for your reference.
                        <br />This will not be displayed anywhere else.
                      </v-tooltip>
                    </template>
                  </v-textarea>
                </v-col>
                <v-col cols="12" md="7"></v-col>
              </v-row>
              <v-btn
                depressed
                class="save rounded-sm white--text ml-0"
                @click="save"
                >save</v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>

    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="theme white--text headline pt-4">
          <v-spacer/>
          <span>Are you sure?</span>
          <v-spacer/>
        </v-card-title>
        <v-divider/>
        <v-card-text class="mt-10 mb-5 text-xs-center body-1"
        >You will not be able to undo this operation.
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-btn class="save rounded-sm white--text" depressed text @click="dialog = !dialog">cancel</v-btn>
          <v-spacer/>
          <v-btn class="action rounded-sm white--text" depressed text @click="deleteDepartment">delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>
<script>
import {mapGetters} from "vuex";

import {Actions} from "@/views/actions";
import {Breadcrumbs} from "@/views/breadcrumbs";
import {Component} from "@/views/component";
import {Constants} from "@/views/constants";

export default {
  name: Component.Protected.Company.Departments.Edit,
  data: () => ({
    breadcrumbs: Breadcrumbs.Departments.Edit,
    tempDisable: false,
    department: {
      name: "",
      description: "",
      count: 0,
    },
    dialog: false,
  }),
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.tempDisable = true;
        const data = { ...this.department };
        let dispatchData = { id: this.$route.params.id, data: data };

        this.$store
          .dispatch(Actions.DepartmentEdit, dispatchData)
          .catch((e) => {
            console.error(Constants.Departments.Messages.Error.Edit, e);
            this.snackbarMessage = Constants.Departments.Messages.Error.Edit;
            this.snackbar = true;
          })
          .finally(() => {
            this.tempDisable = false;
            this.$router.go(-1);
          });
      }
    },
    setup() {
      if (this.userInfo.role !== Constants.Roles.HR) {
        this.$router.go(-1);
        return false;
      }
      this.tempDisable = false;
      this.getDepartment();
    },
    getDepartment() {
      this.tempDisable = true;
      this.$store
        .dispatch(Actions.DepartmentGet, this.$route.params.id)
        .then((r) => {
          if (r.status === 200) {
            this.department = r.data;
          }
        })
        .catch((e) => {
          console.error(Constants.Departments.Messages.Error.Get, e);
          this.snackbar = true;
          this.snackbarMessage = Constants.Departments.Messages.Error.Get;
        })
        .finally(() => (this.tempDisable = false));
    },
    deleteDepartment() {
      if (!this.$route.params.id) return false;
      this.$store
        .dispatch(Actions.DepartmentDelete, this.$route.params.id)
        .then(() => this.$router.go(-1))
        .catch((e) => {
          console.error(Constants.Departments.Messages.Error.Delete, e);
          this.snackbar = true;
          this.snackbarMessage = Constants.Departments.Messages.Error.Delete;
        });
    },
  },
  created() {
    if (!this.$route.params.id) {
      this.$router.go(-1);
      return false;
    }
    if (this.userInfo && this.userInfo.role) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>